export enum ApiEnum {
  AIRCRAFT_API = 'AIRCRAFT API',
  EMAIL_SERVICE_API = 'EMAIL SERVICE API',
  OPERATOR_API = 'OPERATOR API',
  SOURCING_API = 'SOURCING API'
}
